import { im_proto } from '../../proto/index.js';

class RtcParticipant {
    constructor(userId) {
        this.status = im_proto.VoipStatus.UNAVAILABLE;
        // 是否有音频
        this.audio = false;
        // 是否有视频
        this.video = false;
        this.userId = userId;
    }
}

export { RtcParticipant };
//# sourceMappingURL=RtcParticipant.js.map
